export default __webpack_public_path__ + "static/media/album_default.3cf45c6c.png";